var map = {
	"./aparthotelclub/ic_phone_colored.png": 56411,
	"./beachful/ic_phone_colored.png": 16417,
	"./castlepedia/ic_phone_colored.png": 79414,
	"./cocktayl/ic_phone_colored.png": 30279,
	"./ic_phone_colored.png": 81249,
	"./luxresortclub/ic_phone_colored.png": 77938,
	"./parkful/ic_phone_colored.png": 63806,
	"./prefabworld/ic_phone_colored.png": 63204,
	"./rooftopclub/ic_phone_colored.png": 19392,
	"./spaclub/ic_phone_colored.png": 40057,
	"./worldcasino/ic_phone_colored.png": 42542,
	"./zoopedia/ic_phone_colored.png": 34531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57516;